import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle, BarChart3, Brain } from 'lucide-react';
export function ClinicalEvidence() {
  return <section className="py-8 px-3" data-id="element-54">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-55">
        {/* Bloque 1: Criterio clínico */}
        <FadeIn data-id="element-56">
          <div className="bg-surface border border-accent/20 rounded-2xl p-5 md:p-8" data-id="element-57">
            <div className="flex items-center gap-2 mb-3" data-id="element-58">
              <Brain size={22} className="text-accent" data-id="element-59" />
              <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-60">
                Basado en ciencia deportiva real, no en mitos de gimnasio
              </h2>
            </div>

            <p className="text-white/60 mb-4" data-id="element-61">
              Este sistema está construido a partir de:
            </p>

            <ul className="space-y-2.5" data-id="element-62">
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-63">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-64" />
                <span data-id="element-65">
                  Protocolos utilizados con atletas y pacientes reales
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-66">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-67" />
                <span data-id="element-68">
                  Enfoque basado en evidencia científica actualizada (ISSN,
                  ACSM, AIS)
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-69">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-70" />
                <span data-id="element-71">
                  Integración de periodización + suplementación + recuperación
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-72">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-73" />
                <span data-id="element-74">
                  Aplicación práctica pensada para el tiempo real de consulta
                </span>
              </li>
            </ul>

            <div className="mt-5 pt-4 border-t border-white/10 space-y-1.5" data-id="element-75">
              <p className="text-white/50 text-sm italic" data-id="element-76">
                No es teoría. No es contenido académico sin aplicación.
              </p>
              <p className="text-accent font-bold text-sm md:text-base" data-id="element-77">
                Es un sistema pensado para potenciar el rendimiento y la
                composición corporal.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Bloque 2: Qué cambia */}
        <FadeIn delay={0.15} data-id="element-78">
          <div className="bg-surface border border-accent/20 rounded-2xl p-5 md:p-8" data-id="element-79">
            <div className="flex items-center gap-2 mb-3" data-id="element-80">
              <BarChart3 size={22} className="text-accent" data-id="element-81" />
              <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-82">
                ¿Qué cambia cuando aplicás este sistema?
              </h2>
            </div>

            <ul className="space-y-2.5" data-id="element-83">
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-84">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-85" />
                <span data-id="element-86">Reducís el tiempo de armado de cada plan deportivo</span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-87">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-88" />
                <span data-id="element-89">Mejorás la adherencia y los resultados del paciente</span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-90">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-91" />
                <span data-id="element-92">
                  Tenés un criterio claro para pautar suplementación segura
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-93">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-94" />
                <span data-id="element-95">
                  Podés justificar honorarios más altos con respaldo profesional
                </span>
              </li>
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}